import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_right.svg'
import { ReactComponent as YellowIntersect } from 'assets/images/yellow-intersect.svg'
import { Button } from 'components/common/button/Button'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import styles from './ExploreYourResourcesBanner.module.scss'

const ExploreYourResourcesBanner = () => (
  <div className={clsx(mainStyles.container, styles.ExploreYourResourcesBanner)}>
    <div className={styles.wrapper}>
      <div className={styles.intersect}>
        {/* Pixel rendering bug for rounded corners and background colors in browsers */}
        <div className="absolute left-0 h-full w-[20px] bg-[#EBFF00]" />
        <YellowIntersect />
      </div>
      <div className={styles.textContent}>
        <p className={styles.title}>Explore your resources</p>
        <p className={styles.description}>Download the Full XL 3.0 Deck and learn more about The Experience Loop.</p>
      </div>
      <div className={styles.CTA}>
        <Button
          className={styles.CTAText}
          text="Download Full Deck"
          variant="primary"
          onClick={() => {
            window.open(
              'https://facade-api-tccc-prod-coke.playground.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/af2b1132-a859-49b8-a02e-10a18337f406/public-download',
              '_blank',
            )
            trackAnalytics({
              type: AnalyticsActionType.action,
              payload: EVENTS.ACTION.LANDING.DOWNLOAD_FULL_DECK,
            })
          }}
          iconRight={<ArrowIcon />}
        />
      </div>
    </div>
  </div>
)

export default ExploreYourResourcesBanner
